<div class="flex flex-row gap-2">
  @if (!editMode) {
    <div class="px-4 content-center w-[18rem]" (click)="editMode = true">
      {{ name }}
      @if (original !== name) {
        <span class="italic">* {{ 'edit-input.unsaved-changes' | translate }}</span>
      }
    </div>
  }
  @if (editMode) {
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-[18rem]">
      <input matInput [(ngModel)]="name" (blur)="this.editMode = false" autofocus />
      @if (duplicated) {
        <mat-icon
          class="hover:bg-neutral-50 rounded-full stroke-yellow-500"
          matSuffix
          svgIcon="mat:warning"
          [matTooltip]="'Nombre duplicado en cliente'"
        ></mat-icon>
      }
    </mat-form-field>
  }
  @if (original !== name) {
    <button mat-icon-button (click)="emitNewName()">
      <mat-icon matSuffix class="hover:bg-neutral-50 cursor-pointer rounded-full" color="primary" svgIcon="mat:check"></mat-icon>
    </button>
    <button mat-icon-button (click)="emitCancel()">
      <mat-icon matSuffix class="hover:bg-neutral-50 cursor-pointer rounded-full stroke-red-500" svgIcon="mat:close"></mat-icon>
    </button>
  }
</div>
